module.exports = __webpack_public_path__ + "img/problem_paper_dispenser.936f520f.svg";